import { Component, OnInit } from '@angular/core';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listar-apoyo-traspaso',
  templateUrl: './listar-apoyo-traspaso.component.html',
  styleUrls: ['./listar-apoyo-traspaso.component.scss']
  
})
export class ListarApoyoTraspasoComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();

    FORMS: any;
    API: any;
    CODFUNC: any;
    PAGE: any;
    GENERALES: any;

    ordenes;

    // array´s
    arrayApoyosSolicitados = [];

  constructor (
    private network: NetworkHelperService,
    private router: Router
    ) {
        this.FORMS = FORMS;
        this.API = API;
        this.CODFUNC = CODFUNC;
        this.GENERALES = GENERALES;
        // this.usuario = JSON.parse(localStorage.getItem('usuario'));
     }

  ngOnInit() {
    this.getSolicitudesApoyo();
    // this.getApoyosSolicitados();
  }

  getSolicitudesApoyo() {
    this.network.callSecureService(
            this.API.user.almacenes + '/' + this.API.user.listar + '/' + this.API.user.apoyos,
            'GET',
            null)
            .subscribe((response: any) => {
              console.log(response);
              this.ordenes = response.Mensaje.reverse();
              this.dtTrigger.next();
              }, err => {
                console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    getApoyosSolicitados () {
      this.network.callSecureService(
        this.API.user.almacenes + '/' + this.API.user.apoyos + '/' + this.API.user.listar + '/' + this.API.user.solicitados,
        'GET',
        null
      ).subscribe((response: any) => {
        console.log( response );
        this.arrayApoyosSolicitados = response.Mensaje;
        this.dtTrigger2.next();
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      });
    }

    ordenSeleccionada(orden: any) {
      this.router.navigate(['dashboard/menuAlmacen/listarApoyoTraspaso/materialApoyoTraspaso/', orden.ordenTrabajoId ]);
    }

  }




// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-apoyo-traspaso/listar-apoyo-traspaso.component.ts